"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _Crop = _interopRequireDefault(require("@material-ui/icons/Crop32"));

var _Crop2 = _interopRequireDefault(require("@material-ui/icons/Crop54"));

var _Crop3 = _interopRequireDefault(require("@material-ui/icons/Crop75"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var ImageAspectBox = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 10px;\n"])));

var ImageAspectItemsBox = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n"])));

var ImageAspectItemBox = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: pointer;\n  padding: 4px 4px 2px;\n  margin: 0 10px 10px 0;\n  text-align: center;\n  justify-content: center;\n\n  transition: .2s ease-in-out;\n  font-size: 14px;\n\n  i, span {\n    display: block !important;\n  }\n\n  &:hover {\n    background: rgba(0, 118, 223, 0.1);\n    border-radius: 3px;\n  }\n\n  ", "\n"])), function (props) {
  return props.active && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    background: rgba(0, 118, 223, 0.1);\n    border-radius: 3px;\n  "])));
});

var StyledTitle = (0, _styledComponents["default"])(_Typography["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  padding-bottom: 10px;\n"])));

var ImageAspectRatios = function ImageAspectRatios(_ref) {
  var hideAspectsSelector = _ref.hideAspectsSelector,
      setRatio = _ref.setRatio,
      originalRatio = _ref.originalRatio,
      cropAspect = _ref.cropAspect;

  if (hideAspectsSelector) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(ImageAspectBox, null, /*#__PURE__*/_react["default"].createElement(StyledTitle, {
    variant: "h4"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.editImages.ratioTitle"
  })), /*#__PURE__*/_react["default"].createElement(ImageAspectItemsBox, null, /*#__PURE__*/_react["default"].createElement(ImageAspectItemBox, {
    onClick: function onClick() {
      return setRatio(originalRatio);
    },
    active: cropAspect === originalRatio
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "crop_original"
  }), /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.editImages.ratioOriginal"
  })), /*#__PURE__*/_react["default"].createElement(ImageAspectItemBox, {
    active: cropAspect === 1,
    onClick: function onClick() {
      return setRatio(1);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "crop_square"
  }), /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.editImages.ratioSquare"
  })), /*#__PURE__*/_react["default"].createElement(ImageAspectItemBox, {
    active: cropAspect === 0.75,
    onClick: function onClick() {
      return setRatio(0.75);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "crop_portrait"
  }), /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.editImages.ratioPortrait"
  })), /*#__PURE__*/_react["default"].createElement(ImageAspectItemBox, {
    active: cropAspect === 1.5,
    onClick: function onClick() {
      return setRatio(1.5);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Crop["default"], null), /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.editImages.ratioThreeByTwo"
  })), /*#__PURE__*/_react["default"].createElement(ImageAspectItemBox, {
    active: cropAspect === 1.7777,
    onClick: function onClick() {
      return setRatio(1.7777);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Crop2["default"], null), /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.editImages.ratioSixteenByNine"
  })), /*#__PURE__*/_react["default"].createElement(ImageAspectItemBox, {
    active: cropAspect === 1.4,
    onClick: function onClick() {
      return setRatio(1.4);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Crop3["default"], null), /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.editImages.ratioSevenByFive"
  }))));
};

ImageAspectRatios.propTypes = {
  hideAspectsSelector: _propTypes["default"].bool,
  setRatio: _propTypes["default"].func.isRequired,
  cropAspect: _propTypes["default"].any,
  originalRatio: _propTypes["default"].any
};
var _default = ImageAspectRatios;
exports["default"] = _default;